import appliedFiltersStore from './applied-filters-store';
import { logEngagement, logEngagementWithDetails } from "../global/log-engagement";

$(document).on('click', '.js-clear-search', function (e) {
    e.preventDefault();

    const $input = $('.ab854__search__textbox');
    $input.val('').trigger('input').focus();

    updateClearSearchVisibility();
});

$(function() {
  bindResetButton($('.generated__questions'));

  const $originalSearchTerm = $('#original-search-term');
  if ($originalSearchTerm.length) {
    const correctedSearchTerm = $('#smart_search_term').val();
    const originalSearchTerm = $originalSearchTerm.text();
    window.history.replaceState(null, document.title,
      window.location.href.replace('search=' + encodeURIComponent(originalSearchTerm),
        'search=' + correctedSearchTerm));
  }

  $('.js-smart-filters').on('click', function(e) {
    $.modal({
      open: 'smart-filters',
      type: 'custom',
      triggerOpen: true,
      triggerElement: $(this),
      onClose: function() {
        const $form = $('#smart-filters-form');
        const fieldsetId = $form.data('fieldsetId');
        if (fieldsetId) {
          const $fieldset = $(`#${fieldsetId}`);
          const originalIndex = $fieldset.data('index');
          if (originalIndex) {
            $('fieldset', $form).eq(originalIndex - 1).after($fieldset);
          }
        }
        $form.data('fieldsetId', '');
      },
    });
    if (e && e.originalEvent) {
      logEngagement(window.location.href, 'smart_filter_pill_more', 'click');
    }
  });

  $('.js-smart-filter-question').on('click', function(){
    const $this = $(this);
    const fieldsetId = $this.data('fieldsetId');
    $('#smart-filters-form').data('fieldsetId', fieldsetId).prepend($(`#${fieldsetId}`));
    $('.js-smart-filters').trigger('click');
    logEngagementWithDetails(window.location.href, 'smart_filter_pill', 'click', $this.data('category'));
  });
});

function generatePills() {
  const $questionContainer = $('.generated__questions');
  const checkedInputs = $questionContainer.find('input[type="checkbox"]:checked');
  const $pillContainer = $('#selected-filters');
  const $filteredText = $('#filtered-text');
  const $filtersContainer = $('.filters-container');

  $pillContainer.html('');
  const $ul = $('<ul>');
  $ul.addClass('horizontal-scroll__item-wrap u-margin-b--none');

  checkedInputs.each(function () {
    $ul.append(generatePillListItem($(this), $questionContainer, $filteredText));
  });

  if (checkedInputs.length > 0) {
    let $clearBtn = $('.clear-btn', $filtersContainer);
    if (!$clearBtn.length) {
      $clearBtn = $('<button>');
      $clearBtn.addClass('clear-btn pill-button pill-button--black u-white-space--nowrap u-margin-l--lg');
      $clearBtn.text('Clear Filters');

      $clearBtn.on('click', () => {
        $('input[type="checkbox"]', $questionContainer).prop('checked', false);
        $pillContainer.html('');
        $filteredText.addClass('u-hide');
        $clearBtn.remove();
        $('#submit-smart-filters').trigger('click');
      });

      $filteredText.removeClass('u-hide');
      $($filtersContainer).append($clearBtn);
    }
  } else {
    $('#filtered-text').addClass('u-hide');
    $('.clear-btn').remove();
  }

  $pillContainer.append($ul);
  setTimeout(() => {
    const $scrollEl = $('.js-horizontal-scroll');
    if ($scrollEl.length && typeof $scrollEl.horizontalScroll === 'function') {
      $scrollEl.horizontalScroll();
    }
  }, 0);

  $('.js-modal-close').trigger('mousedown');
  $('.js-clear-search').show();
}

function generatePillListItem($input, $questionContainer, $filteredText) {
  const inputId = $input.attr('id');
  const label = $questionContainer.find(`label[for="${inputId}"] .push-button__copy`).text().trim();
  if (!label) return;

  const $li = $('<li class="horizontal-scroll__item horizontal-scroll__item--basis-none">');
  const $pill = $(`<div class="pill-button pill-button--light-grey" data-input-id="${inputId}">`);
  const $span = $('<span>');
  $span.text(label);
  $pill.append($span);

  const $closeBtn =$('<button type="button" class="u-margin-l--xs">');
  $closeBtn.html(`
        <span class="icon icon--x">
          <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
            <path d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z"></path>
          </svg>
        </span>`);

  $closeBtn.on('click', () => {
    $input.prop('checked', false);
    const $ul = $li.closest('ul');
    $li.remove();
    if (!$ul.children().length) {
      $('.clear-btn').remove();
      $filteredText.addClass('u-hide');
      $('#reset-smart-filters').trigger('click');
    } else {
      $input.trigger('change');
      $('#submit-smart-filters').trigger('click');
    }
  });

  $pill.append($closeBtn);
  $li.append($pill);

  return $li;
}

// NEW: UX-19852
var smartFiltersQuestionId = null;

$(document).on('click', '.smart-filters-mock', function () {
    $.modal({
        url: 'smartFiltersModal.html',
        type: 'custom',
        triggerOpen: true,
        triggerElement: $(this),
        onComplete: initSmartFiltersModalMain
    });
});

// NEW: UX-19852
$(document).on('click', '.js-smart-filter-question-mock', function () {
    smartFiltersQuestionId = $(this).data('question-id') || null;

    $.modal({
        url: 'smartFiltersModal.html',
        type: 'custom',
        triggerOpen: true,
        triggerElement: $(this), // the pill is the opener for focus/ARIA purposes
        onComplete: initSmartFiltersModalMain
    });
});

function getSearchScope(el) {
    const $modal = $(el).closest('.modal');
    return $modal.length ? $modal : $(document);
}

function updateClearSearchVisibility($scope) {
    const $input = $scope.find('.ab854__search__textbox').first();
    const $clear = $scope.find('.js-clear-search').first();

    if (!$input.length || !$clear.length) return;

    const hasText = $.trim($input.val()).length > 0;
    const isFocused = $input.is(':focus');

    // your requirement: show only when focused + has text
    $clear.toggle(hasText && isFocused);
}

// bind for both modal + page inputs
$(document)
    .off('input.ab854 focus.ab854 blur.ab854', '.ab854__search__textbox')
    .on('input.ab854', '.ab854__search__textbox', function () {
        updateClearSearchVisibility(getSearchScope(this));
    })
    .on('focus.ab854', '.ab854__search__textbox', function () {
        updateClearSearchVisibility(getSearchScope(this));
    })
    .on('blur.ab854', '.ab854__search__textbox', function () {
        const $scope = getSearchScope(this);
        setTimeout(() => updateClearSearchVisibility($scope), 0);
    });

// clear button: clears textbox in same scope (modal clears modal input, page clears page input)
$(document)
    .off('pointerdown.ab854 mousedown.ab854', '.js-clear-search')
    .on('pointerdown.ab854', '.js-clear-search', function (e) {
        e.preventDefault();

        const $scope = getSearchScope(this);
        const $input = $scope.find('.ab854__search__textbox').first();

        if (!$input.length) return;

        $input.val('').trigger('input').focus();
        updateClearSearchVisibility($scope);
    });


// NEW: UX-19852
function reorderSmartFilterQuestions($questionContainer, questionId) {
    if (!questionId) return;

    // Find the fieldset with the matching data-question-id
    var $target = $questionContainer.find('fieldset[data-question-id="' + questionId + '"]').first();
    if (!$target.length) return;

    // Move it to the top
    $target.prependTo($questionContainer);
}

function initSmartFiltersModalMain() {
    $.ajax({
        url: 'smartFilterModalQuestions.html',
        success: function (response) {
            const $questionContainer = $('.generated__questions');
            $questionContainer.empty().append(response);
            $('.loading').hide();

            if (smartFiltersQuestionId) {
                reorderSmartFilterQuestions($questionContainer, smartFiltersQuestionId);
                smartFiltersQuestionId = null;
            }

            // Bind store sync (modal -> store)
            bindModalFilterStoreSync($questionContainer);

            // Sync modal UI from store (store -> modal)
            syncModalFromStore($questionContainer);

            // Submit just closes
            bindSubmitHandler();

            // Reset clears store + closes
            bindResetButton($questionContainer);
        }

    });
    updateClearSearchVisibility($('.modal'));
}

function syncModalFromStore($questionContainer) {
  const selectedIds = new Set(
    appliedFiltersStore.getAll()
      .filter(f => f.source === 'smartModal')
      .map(f => f.id)
      .filter(Boolean)
  );

  $questionContainer.find('input[type="checkbox"]').each(function () {
    const $input = $(this);
    const id = $input.data('smart-id') || $input.attr('id');
    if (!id) return;

    $input.prop('checked', selectedIds.has(id));
  });
}


function toModalFilter($input, $questionContainer) {
  const id = $input.data('smart-id') || $input.attr('id') || null;

  // Find label text reliably (works even when input is not nested in label)
  let label = '';
  if (id) {
    label = $questionContainer
      .find(`label[for="${CSS.escape(id)}"] .push-button__copy`)
      .first()
      .text()
      .trim();
  }

  // Fallbacks (in case markup varies)
  if (!label) {
    label = $input.closest('fieldset').find('.push-button__copy').first().text().trim();
  }

  return {
    type: 'smart',
    source: 'smartModal',
    id, // IMPORTANT: should be stable (prefer data-smart-id if possible)
    name: $input.data('question-id') || null,
    value: $input.val() || $input.data('value') || null,
    label,
  };
}


function bindModalFilterStoreSync($questionContainer) {
  $questionContainer
    .off('change.smartModalStore', 'input[type="checkbox"]')
    .on('change.smartModalStore', 'input[type="checkbox"]', function () {
      const $input = $(this);
      const f = toModalFilter($input, $questionContainer);

      // If we can't identify or label it, don't write garbage into store
      if (!f.id || !f.label) return;

      if ($input.prop('checked')) appliedFiltersStore.upsert(f);
      else appliedFiltersStore.remove(f);
    });
}



function bindSubmitHandler() {
    $(document)
        .off('click.smartFiltersSubmit', '.submit-questions')
        .on('click.smartFiltersSubmit', '.submit-questions', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // No pill building here. Pills render from store.
            $('.js-modal-close').trigger('mousedown');
            updateClearSearchVisibility();
        });
}

function bindResetButton($container) {
  $(document)
    .off('click.smartFiltersReset', '#reset-smart-filters')
    .on('click.smartFiltersReset', '#reset-smart-filters', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Uncheck modal UI (optional; store.clear() will also cause a rerender)
      $container.find('input[type="checkbox"]').prop('checked', false);

      // Clear unified state (this drives page pills)
      appliedFiltersStore.clear();

      // Clear search UI bits if needed
      $('.ab854__search__textbox').val('');
      updateClearSearchVisibility($('.modal'));

      $('.js-modal-close').trigger('mousedown');
    });
}


// Mock Content End



// WEBPACK FOOTER //
// ./src/scripts/modules/abtest/smart-filters.js